import { mapState } from 'vuex'
import moment from 'moment'
import { capacityControlModes } from '@/config'
import { colonHourToMs } from '@/lib/helpers/HoursFormatter'

export default {
  computed: {
    ...mapState(['activities']),
    maximumCapacity () {
      return this.reservationMethod ? this.reservationMethod.maximumCapacityPerSlot : null
    },
  },
  methods: {
    getCapacityStatus ({
      slot = this.slot,
      currentAttendees = this.people,
      max = this.maximumCapacity,
      date = this.date,
      over = false, // Returns true if capacity is over...
      reached = false, // ... or reached
    }) {
      const ms = colonHourToMs(slot)
      if (typeof ms === 'number' && max && (over || reached)) {
        const slotCapacity = this.activities.capacityPerSlot
          .find((slotCapacity) => (
            slotCapacity.reservationMethod === this.reservationMethod.type &&
            slotCapacity.date === date &&
            slotCapacity.hour === ms
          ))
        const currentCapacity = slotCapacity ? slotCapacity.currentCapacity : 0
        if (this.reservationMethod.capacityControlMode === capacityControlModes.RESERVATIONS) currentAttendees = 1
        return over
          ? currentAttendees + currentCapacity > max
          : reached
            ? currentAttendees + currentCapacity >= max
            : false
      }
      return false
    },
    getSlotCapacity ({
      slot = this.slot,
      date = this.date,
      save = true,
      activityId = this.$route.params.activityId,
    } = {}) {
      const requestedMoment = this.getReservationRequestedMoment({
        requestedDate: date,
        requestedTime: colonHourToMs(slot),
      })
      return this.$store.dispatch('activities/listCapacityPerSlot', {
        id: activityId,
        since: requestedMoment.toISOString(),
        until: requestedMoment.add(1).toISOString(),
        save,
      }).catch(() => {})
    },
    getReservationRequestedMoment (reservation) {
      return moment(reservation.requestedDate, 'YYYY-MM-DD').add({
        minute: moment().utcOffset(),
        millisecond: reservation.requestedTime,
      })
    },
  },
}
